function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var a = {
  regular: "400",
  medium: "500",
  bold: "800"
},
    d = function d(_ref) {
  var t = _ref.weight,
      o = _ref.color,
      e = _ref.decoration,
      n = _ref.transform,
      _ref$style = _ref.style,
      r = _ref$style === void 0 ? {} : _ref$style;
  return _objectSpread({
    fontWeight: t ? a[t] : void 0,
    textDecoration: e,
    color: o,
    textTransform: n
  }, r);
};

export { d as addInlineStyles };